const typegraphy = {
    fontFamily: '"SF Pro Text Regular',
    fontSize: '20px',
    '@media (min-width: 768px)': {
        fontSize: '18pt'
    },
    lineHeight: 1.5,
    h1: {
        fontWeight: 500,
        fontSize: 35,
        letterSpacing: '-0.24px',
        fontFamily: 'HOUSE3009 Spaceage-Heavy-Round'
    },
    h2: {
        fontWeight: 500,
        fontSize: 29,
        letterSpacing: '-0.24px',
        fontFamily: 'HOUSE3009 Spaceage-Heavy-Round'
    },
    h3: {
        fontWeight: 500,
        fontSize: 24,
        letterSpacing: '-0.06px',
        fontFamily: 'HOUSE3009 Spaceage-Heavy-Round'
    },
    h4: {
        fontWeight: 500,
        fontSize: 20,
        letterSpacing: '-0.06px',
        fontFamily: 'HOUSE3009 Spaceage-Heavy-Round'
    },
    h5: {
        fontWeight: 500,
        fontSize: 16,
        letterSpacing: '-0.05px',
    },
    h6: {
        fontWeight: 500,
        fontSize: 14,
        letterSpacing: '-0.05px',
    },
    overline: {
        fontWeight: 500
    }
}

export default typegraphy
